import {api} from "./AxiosInstance";

export const GetPolicyMenuItemsApi = async (type) => api.get(`/employee-connect/policies/${type}`);

export const GetPolicyNamesApi = async () => api.get('/employee-connect/policies/admin/names');

export const AddPolicyApi = async (formData) => api.post('/employee-connect/policies/admin', formData, {
    headers: {
        "Content-type": "multipart/form-data",
    }
});

export const DeletePolicyApi = async (id) => api.delete(`/employee-connect/policies/admin/${id}`);